const Footer = () => {
  return (
    <div className='footer-wrapper'>
      <footer>
        <span>&copy; {new Date().getFullYear()} All Rights Reserved</span>
        <span>Dawood Arif</span>
      </footer>
    </div>
  );
};

export default Footer;
